// Enter all your detials in this file
// Logo images
import logogradient from "./assets/RAKHA_LOGO.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.png";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
import nextjs from "./assets/techstack/nextjs.svg";
import unity from "./assets/techstack/unity.svg";
import angular from "./assets/techstack/angular.svg";
import springboot from "./assets/techstack/springboot.svg";
import kotlin from "./assets/techstack/kotlin.svg";
import reactnative from "./assets/techstack/reactnative.svg";
import cursor from "./assets/techstack/cursor.svg";
import claude from "./assets/techstack/claude.svg";
import gemini from "./assets/techstack/googlegemini.svg";
import chatgpt from "./assets/techstack/openai.svg";
import canva from "./assets/techstack/canva.svg";
import notion from "./assets/techstack/notion.svg";
import postgresql from "./assets/techstack/postgresql.svg";
import mongodb from "./assets/techstack/mongodb.svg";
import aws from "./assets/techstack/aws.svg";
import slack from "./assets/techstack/slack.svg";
import discord from "./assets/techstack/discord.svg";
import vercel from "./assets/techstack/vercel.svg";
import netlify from "./assets/techstack/netlify.svg";
import cloudflare from "./assets/techstack/cloudflare.svg";
import firebase from "./assets/techstack/firebase.svg";
// Porject Images
import projectImage1 from "./assets/projects/utconnect-app.png"; //utconnect
import projectImage2 from "./assets/projects/utportal-web.png"; //utportal
import projectImage3 from "./assets/projects/mysimba-app.png"; //simba app
import projectImage4 from "./assets/projects/simba-web.png"; //simba web
import projectImage5 from "./assets/projects/edot-app.png"; //edot app
import projectImage6 from "./assets/projects/edot-web.png"; //edot web
import projectImage7 from "./assets/projects/storeberry.png"; //storeberry hk
import projectImage8 from "./assets/projects/greenhoop.png"; //greenhoop hk
import projectImage9 from "./assets/projects/ar.png"; //ar hk
// Porject Videos
import arHkVideo from "./assets/video/AR-HK.mp4"; //AR 3D Hongkong Maps

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Rakha Hidayat Wakid",
  tagline: "I build things for web & application",
  img: profile,
  about: `I am a skilled Software Engineer with over seven years of professional experience across various industries. I began my career at United Tractors Tbk., where I contributed to developing mobile and web applications for internal monitoring systems. After gaining valuable experience, I moved on to PT. Nagendra Kreasi Indonesia and later joined Simba Telecom PTE. LTD. SG, where I worked on apps focused on managing internet quotas and user subscriptions.`,
  about2: `Currently, I work at OpenLoop Health, where I play a key role as Full Stack Developer. My expertise lies in technologies like React Native, JavaScript, React.JS, TypeScript, Angular, and Next.JS, Spring Boot, Kotlin and Unity, which I have applied in projects such as UT Connect, My SIMBA, eDOT and Wistkey.`,
  about3: `I hold a degree in Computer and Network Engineering from Vocational High School 8 Malang and a Bachelor of Information Technology from the Polytechnic State of Malang. My strong technical background helps me create dynamic user experiences across both mobile and web platforms.`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/rakha-hidayat-4064b81a0/",
  github: "https://www.github.com/rakhahidayat",
  // twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/rhw23",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Full Stack Developer",
    Company: `OpenLoop Health`,
    Location: "United States (Remote)",
    Type: "Contract Based",
    Duration: "May 2026 - Present",
  },
  {
    Position: "Senior Analyst Programmer",
    Company: `Wistkey`,
    Location: "Hong Kong (Remote)",
    Type: "Freelance",
    Duration: "October 2025 - June 2026",
  },
  {
    Position: "Senior Frontend Developer",
    Company: `PT. EDOT`,
    Location: "Bandung (Remote)",
    Type: "Full Time",
    Duration: "Nov 2022 - May 2026",
  },
  {
    Position: "Software Engineer",
    Company: `Simba Telecom PTE. LTD. SG`,
    Location: "Singapore (Remote)",
    Type: "Full Time",
    Duration: "Nov 2021 - Nov 2022",
  },
  {
    Position: "Software Engineer",
    Company: `PT. Nagendra Kreasi Indonesia`,
    Location: "Jakarta",
    Type: "Contract Based",
    Duration: "Feb 2021 - Nov 2021",
  },
  {
    Position: "Frontend Developer",
    Company: `United Tractors Tbk.`,
    Location: "Jakarta",
    Type: "Contract Based",
    Duration: "Aug 2019 - Feb 2021",
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Bachelor of Information Technology",
    Company: `Polytechnic State of Malang`,
    Location: "Malang",
    Type: "Graduated",
    Duration: "2015 - 2019",
  },
  {
    Position: "Computer and Network Engineering",
    Company: "Vocational High School 8 Malang",
    Location: "Malang",
    Type: "Graduated",
    Duration: "2012 - 2015",
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  nextjs: nextjs,
  angular: angular,
  reactnative: reactnative,
  kotlin: kotlin,
  springboot: springboot,
  unity: unity,
  notion: notion,
  postgresql: postgresql,
  mongodb: mongodb,
  aws: aws,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
  cursor: cursor,
  claude: claude,
  gemini: gemini,
  chatgpt: chatgpt,
  canva: canva,
  slack: slack,
  discord: discord,
  vercel: vercel,
  netlify: netlify,
  cloudflare: cloudflare,
  firebase: firebase,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "UT Connect",
    image: projectImage1,
    description: `A monitoring application to detect total number of heavy equipment units that have been held by consumers to find out what fuel has been used and location of the unit.`,
    techstack: "React-Native, JavaScript",
    previewLink:
      "https://play.google.com/store/apps/details?id=com.unitedtractors.customer_portal",
  },
  {
    title: "UT PORTAL",
    image: projectImage2,
    description: `Website for internal user to handle and monitoring user from mobile app "UT Connect"`,
    techstack: "HTML/CSS, React.JS, JavaScript",
    previewLink: "https://utportal.unitedtractors.com/",
  },
  {
    title: "My SIMBA",
    image: projectImage3,
    description: `Mobile App for user to see their detail Internet Quota and to subscribe or purchase another Plan for their Internet Quotas in Singapore`,
    techstack: "React-Native, JavaScript",
    previewLink: "https://play.google.com/store/apps/details?id=com.tpg_sg",
  },
  {
    title: "SIMBA.SG",
    image: projectImage4,
    description: `Website landing page using React for customer to choose Plan for their Internet Quotas. Registration page using Angular.`,
    techstack: "React.JS, React-Native, JavaScript",
    previewLink: "https://simba.sg",
  },
  {
    title: "eDOT",
    image: projectImage5,
    description: `Mobile application React-Native this apps have a Social Media, eCommerce, Messaging and Food Delivery or we usually call it SuperApp.`,
    techstack: "React-Native, TypeScript",
    previewLink:
      "https://play.google.com/store/apps/details?id=com.pmaapp.ehashtag",
  },
  {
    title: "EDOT.ID",
    image: projectImage6,
    description: `Website landing page using Next.JS for customer to offer PoS feature from eDOT. Any other web can redirect from this web that call name eSuite, eWork, etc`,
    techstack: "Next.JS, TypeScript",
    previewLink: "https://edot.id/",
  },
  {
    title: "Storeberry HK",
    image: projectImage7,
    description: `A SaaS-based e-commerce platform that enables businesses to create and manage customized online stores through an integrated CMS. The solution simplifies online selling, product management, and digital storefront administration.`,
    techstack: "JavaScript, React, Node.js, Spring Boot",
    previewLink: "https://www.storeberry.ai/",
  },
  {
    title: "Green Hoop HK",
    image: projectImage8,
    description: `Digital recycling platform that connects businesses recyclers and logistics providers through online collection requests, tracking and warehouse management. The platform provides end-to-end traceability of recyclable materials.`,
    techstack: "JavaScript, React, ReactNative, Spring Boot",
    previewLink: "https://astd.com.hk/green-hoop/",
  },
  {
    title: "AR 3D Hongkong Maps",
    image: projectImage9,
    video: arHkVideo,
    description: `An Augmented Reality application that uses image recognition technology to display interactive 3D content based on predefined visual markers. The solution supports immersive user experiences for educational, marketing, and product demonstration purposes.`,
    techstack: "JavaScript, Unity, AR.js",
    previewLink: "",
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "rakhahidayatwakid23@gmail.com",
};
